import { DIVIDER } from '../constants';
import type { DividerElement } from '../types';

/** create a divider element */
export const createDivider = (): DividerElement => {
    return { type: DIVIDER, children: [{ text: '' }] };
};
